import { useNavigate } from "react-router-dom";

const HeaderWithLogo = () => {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 z-50 border-b">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-2">
          <button 
            onClick={() => navigate("/")} 
            className="text-2xl font-bold text-primary hover:opacity-90 transition-opacity flex items-center gap-2"
          >
            <img 
              src="/LogoPorteroYa.svg" 
              alt="PorteroYa Logo" 
              className="h-14 w-auto"
            />
            <span>PorteroYa</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default HeaderWithLogo;